module.exports = __webpack_public_path__ + "static/media/medicalOffices.620c08bd.jpg";